module.exports = __webpack_public_path__ + "img/down.053cd154.png";